__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/ba8b561b83c18f0fdc60ea85b56a821d89dc20e4045a4a942fa1361c/";